import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { eCongThucTinhDiemSubtIds, ICongThucTinhDiemSubActionTypeBase, ICongThucTinhDiemSubActionTypes } from "../../action-types/category/ICongThucTinhDiemSubActions";
import { congThucTinhDiemSubApi } from "../../../api/category/congThucTinhDiemSubApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ICongThucTinhDiemSub } from "../../../model/response/category/ICongThucTinhDiemSub";

const mainAction = rootActions.category.congThucTinhDiemSub;

export function* congThucTinhDiemSubSaga(): any {
    yield takeLatest(eCongThucTinhDiemSubtIds.LOAD_BY_CONG_THUC_START, loadWorker);
    yield takeEvery(eCongThucTinhDiemSubtIds.SAVE_START, saveWorker);
}
export function* loadWorker(action: ICongThucTinhDiemSubActionTypes): any {
    const id_cong_thuc = action.payload as number;
    const res: IBaseResponse = yield call(congThucTinhDiemSubApi.SelectByCongThuc, id_cong_thuc);
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_CONG_THUC_SUCCESS({id_cong_thuc, data: toLowerCaseDeep(res.data)}));
    } else {
        yield put(mainAction.LOAD_BY_CONG_THUC_ERROR({id_cong_thuc, data: res.message ?? "Có lỗi"}));
    }
}

function* saveWorker(action: ICongThucTinhDiemSubActionTypes): any {
     try {
    const payload = action.payload as ICongThucTinhDiemSubActionTypeBase<ICongThucTinhDiemSub[]>;
    const id_cong_thuc = payload.id_cong_thuc;
    const congThucSubs = payload.data;
    let countError = 0;
    for (const sub of congThucSubs) {
            let res: IBaseResponse;
            
            if (sub.id_cong_thuc_sub < 0) {
                // Xóa: nếu id_cong_thuc_sub âm, lấy giá trị tuyệt đối để xóa
                const deleteId = Math.abs(sub.id_cong_thuc_sub);
                res = yield call(congThucTinhDiemSubApi.Delete, deleteId);
                if (!res.is_success) {
                    countError +=1;
                }
            } 
            else if (sub.id_cong_thuc_sub > 0) {
                // Cập nhật: nếu id_cong_thuc_sub > 0
                res = yield call(congThucTinhDiemSubApi.Update, sub.id_cong_thuc_sub, sub);       
                 if (!res.is_success) {
                    countError +=1;
                }
            } 
            else {
                // Thêm mới: nếu id_cong_thuc_sub = 0
                res = yield call(congThucTinhDiemSubApi.Insert, sub);
                 if (!res.is_success) {
                    countError +=1;
                }
            }
        }
        if (countError > 0) {
            // Nếu có lỗi, dispatch error
            yield put(mainAction.SAVE_ERROR({ 
                id_cong_thuc: id_cong_thuc, 
                data: `Có ${countError} lỗi xảy ra trong quá trình lưu`
            }));
            return;
        }
        else {
            // Nếu không có lỗi, dispatch success
            yield put(mainAction.SAVE_SUCCESS({ id_cong_thuc: id_cong_thuc, data: congThucSubs }));
        }
     } catch (error) {
        const payload = action.payload as ICongThucTinhDiemSubActionTypeBase<ICongThucTinhDiemSub[]>;
        yield put(mainAction.SAVE_ERROR({ 
            id_cong_thuc: payload?.id_cong_thuc || 0, 
            data: "Có lỗi xảy ra"
        }));
    }
}